import { Navigate, RouteObject, useLocation } from 'react-router-dom';
import PortalLayout from '../components/common/PortalLayout';
import MyAccount from '../pages/portal/MyAccount';
import Logs from '../pages/portal/Logs';
import DataVaultRouting from '../pages/portal/configurations/DataVault/DataVaultRouting';
import Keys from '../pages/portal/configurations/Keys';
import Workflows from '../pages/portal/workflows/Workflows';
import Reports from '../pages/portal/Reports';
import AnalyticsHub from '../pages/portal/AnalyticsHub';
import LLMRouting from '../pages/portal/configurations/LLMRouting';
import AccessSettings from '../pages/portal/configurations/AccessSettings';
import WorkflowBuilder from '../pages/portal/workflowbuilder/flowbuilder';
import FlowBuilderConsole from '../pages/portal/workflowbuilder/flowBuilderConsole';
import WorkflowEditor from '../pages/portal/workflowbuilder/flowBuilderConsole';
import Deployments from '../pages/portal/configurations/Deployment';
import Dashboard from '../pages/portal/Dashboard/Dashboard';
import Agents from '../pages/portal/configurations/agents/Agents';
import IngestionList from '../pages/portal/configurations/ingestion/Data-Ingestion';
import KnowledgeBaseList from '../pages/portal/configurations/KnowledgeBase/KnowledgeBaseList';
import DataSourceListingPage from '../pages/portal/configurations/KnowledgeBase/KnowledgeBaseList';
import IngestionSchedules from '../pages/portal/configurations/ingestion/IngestionSchedules';
import SystemSettings from '../pages/portal/configurations/Settings/SystemSettings';
import IntentModelListing from '../pages/portal/Intent/IntentModelListing';
import PrivateRoute from './PrivateRoute';
import AgentStudio from '../pages/portal/configurations/agents/AgentStudio/AgentStudio';

import ApplicationListing from '../pages/portal/applications/components/ApplicationListings';
import ChatAgents from '../pages/portal/chatagents/new/ChatAgents';
import ChatAgentGenerator from '../pages/portal/chatagents/new/ChatAgentsLayout';
import ConversationGraphBuilder from '../pages/portal/chatagents/new/ChatIntents/ConversationGraphBuilder';
import ConnectionsPage from '../pages/portal/Connections/ConnectionsPage';
import MCPDashboard from '../pages/portal/MCP/Dashboard/MCPDashboard';  
import ResourceAccess from '../pages/portal/MCP/Developers/ResourceAccess';
import MCPResources from '../pages/portal/MCP/MCPResources/MCPResources';
import MCPLiveMonitor from '../pages/portal/MCP/LiveMonitor/LiveMonitor';

const wrapAdmin = (element: React.ReactElement) => (
  <PrivateRoute requireAdmin>{element}</PrivateRoute>
);

function LegacyAnalyticsHubRedirect() {
  const { search } = useLocation();
  return <Navigate to={`/portal/analytics-hub${search}`} replace />;
}

const portalRoutes: RouteObject = {
  path: '/portal',
  element: wrapAdmin(<PortalLayout />),
  children: [
    { path: 'workflows', element: wrapAdmin(<Workflows />) },
    { path: 'reports', element: wrapAdmin(<Reports />) },
    { path: 'analytics-hub', element: wrapAdmin(<AnalyticsHub />) },
    { path: 'reports-builder', element: wrapAdmin(<LegacyAnalyticsHubRedirect />) },
    {
      path: 'configurations',
      children: [
        { path: 'keys', element: wrapAdmin(<Keys />) },
        { path: 'data-ingestion', element: wrapAdmin(<IngestionList />) },
        { path: 'llm-routing', element: wrapAdmin(<LLMRouting />) },
        { path: 'data-vault', element: wrapAdmin(<DataVaultRouting />) },
        { path: 'schedules', element: wrapAdmin(<IngestionSchedules />) }
      ],
    },
    { path: 'knowledge-base', element: wrapAdmin(<KnowledgeBaseList />) },
    { path: 'logs', element: wrapAdmin(<Logs />) },
    { path: 'my-account', element: wrapAdmin(<MyAccount />) },
    { path: 'access-settings', element: wrapAdmin(<AccessSettings />) },
    { path: 'connections', element: wrapAdmin(<ConnectionsPage />) },
    { path: 'flowbuilder/:workflowId', element: wrapAdmin(<WorkflowEditor />) },
    { path: 'flowbuilder', element: wrapAdmin(<WorkflowEditor />) },
    { path: 'deployments', element: wrapAdmin(<Deployments />) },
    { path: 'agents', element: wrapAdmin(<Agents />) },
    { path: 'home', element: wrapAdmin(<Dashboard />) },
    { path: 'system-settings', element: wrapAdmin(<SystemSettings />) },
    { path: 'agentStudio', element: wrapAdmin(<AgentStudio />) },
    { path: 'applications', element: <ApplicationListing /> },
    { path: 'intent-orchestration', element: wrapAdmin(<IntentModelListing />) },
    { path: 'chatagent', element: <ChatAgents /> },
    { path: 'createchatagent', element: <ChatAgentGenerator /> },
    { path: 'mcpdashboard', element: <MCPDashboard /> },
    { path: 'mcpdevelopers', element: <ResourceAccess /> },
    { path: 'mcpresources', element: <MCPResources /> },
    { path: 'mcplivemonitor', element: <MCPLiveMonitor /> },
    {
      path: 'chatbot/:chatbotId',
      element: <ChatAgentGenerator />,
    },
    {
      path: 'agentStudio/:agentId',
      element: wrapAdmin(<AgentStudio />),
    }
  ],
};

export default portalRoutes;
